(function () {
  class ReviewsSlider {
    constructor(el) {
      this.track = el.querySelector('.reviews__track');
      if (!this.track) return;

      this.prevBtns = el.querySelectorAll('.reviews__navBtn--prev');
      this.nextBtns = el.querySelectorAll('.reviews__navBtn--next');

      this._cloneCards();

      this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.scroll(-1)));
      this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.scroll(1)));

      this.track.addEventListener('scroll', () => this.updateActive(), { passive: true });

      this.updateActive();
    }

    _cloneCards() {
      this.originals = Array.from(this.track.querySelectorAll('.reviews__card'));
      this.originals.forEach(card => {
        const clone = card.cloneNode(true);
        clone.dataset.clone = 'true';
        this.track.appendChild(clone);
      });
    }

    _getStep() {
      const card = this.originals[0];
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.offsetWidth + gap;
    }

    scroll(dir) {
      const step = this._getStep();
      if (!step) return;
      const loopWidth = step * this.originals.length;

      if (dir < 0 && this.track.scrollLeft < step * 0.1) {
        this.track.scrollTo({ left: loopWidth, behavior: 'instant' });
      }

      this.track.scrollBy({ left: dir * step, behavior: 'smooth' });

      if (dir > 0) {
        clearTimeout(this._loopTimer);
        this._loopTimer = setTimeout(() => {
          if (this.track.scrollLeft >= loopWidth) {
            this.track.scrollTo({ left: this.track.scrollLeft - loopWidth, behavior: 'instant' });
            this.updateActive();
          }
        }, 450);
      }
    }

    updateActive() {
      const allCards = Array.from(this.track.querySelectorAll('.reviews__card'));
      const trackLeft = this.track.getBoundingClientRect().left;

      let closestCard = allCards[0];
      let minDiff = Infinity;

      allCards.forEach(card => {
        const diff = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (diff < minDiff) {
          minDiff = diff;
          closestCard = card;
        }
      });

      let activeOriginal;
      if (closestCard.dataset.clone === 'true') {
        const clones = Array.from(this.track.querySelectorAll('[data-clone="true"]'));
        activeOriginal = this.originals[clones.indexOf(closestCard)];
      } else {
        activeOriginal = closestCard;
      }

      this.originals.forEach(c => c.classList.remove('reviews__card--active'));
      if (activeOriginal) activeOriginal.classList.add('reviews__card--active');
    }
  }

  function init() {
    document.querySelectorAll('.reviews').forEach(el => new ReviewsSlider(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();